import { render, staticRenderFns } from "./AddCpvsToTenderModal.vue?vue&type=template&id=bcf9e76c&scoped=true&"
import script from "./AddCpvsToTenderModal.vue?vue&type=script&lang=js&"
export * from "./AddCpvsToTenderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf9e76c",
  null
  
)

export default component.exports